import React, { useState, useCallback, useEffect } from 'react';
import Globe from './components/Globe';
import MediaViewer from './components/MediaViewer';
import { MediaItem } from './types/MediaItem';

const App: React.FC = () => {
  const [selectedMedia, setSelectedMedia] = useState<MediaItem | null>(null);

  const handleMediaSelect = useCallback((media: MediaItem | null) => {
    console.log('Media selected:', media);
    setSelectedMedia(media);
  }, []);

  const handleCloseMediaViewer = useCallback(() => {
    console.log('Closing MediaViewer');
    setSelectedMedia(null);
  }, []);

  useEffect(() => {
    console.log('selectedMedia changed:', selectedMedia);
  }, [selectedMedia]);

  return (
    <div className="App">
      <Globe onMediaSelect={handleMediaSelect} />
      {selectedMedia && (
        <MediaViewer item={selectedMedia} onClose={handleCloseMediaViewer} />
      )}
       <footer style={{ position: 'fixed', bottom: 10, left: 10, color: '#fff', fontSize: '10px' }}>
        気象災害データ: Global Disaster Alert and Coordination System
        {/*台風経路データ: Joint Typhoon Warning Center<br />*/}
        {/*気象予測データ: Seasonal climate forecast from CFSv2*/}
      </footer> {/* データソースを追加 */}
    </div>
  );
};

export default App;